import type { Router } from 'vue-router';
import { useFeatureStoreWithOut } from '/@/store/modules/feature';

const featureStore = useFeatureStoreWithOut();
/**
 * 初始化特性开关，拉取最新的开关配置
 */
export function initFeaturesConfig() {
  return featureStore.fetchFeatures();
}

/**
 * 根据特性开关名称获取特性开关状态
 * @param name 特性开关名称
 * @returns 特性开关状态
 */
export function getFeatureStateByName(name: string) {
  return featureStore.getFeatureStateByName(name);
}

/**
 * 根据特性开关过滤路由
 * @param routes 原始路由
 * @returns 过滤后的路由
 */
export function filterRoutesByFeature(router: Router): Router {
  router.getRoutes().forEach((route) => {
    const { name } = route;
    if (
      name &&
      router.hasRoute(name) &&
      route.meta?.feature &&
      !getFeatureStateByName(route.meta.feature as string)
    ) {
      // 剔除不允许访问的路由
      router.removeRoute(name);
    }
  });
  return router;
}

export function resetFeatures() {
  initFeaturesConfig();
}
